const TabListTableCellWidthEnum=
{
    Single:'Single',
    Double:'Double',
    Full:'Full',
    TwoLines:'TwoLines',
    Table:"Table"
};

export default TabListTableCellWidthEnum;